import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { LineModel } from '@data-layer/models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class LineItemsCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public create(invoiceId: number, item: Partial<LineModel>): Observable<LineModel> {
    return this.apiService.post<LineModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/invoices/${invoiceId}/line-items`,
      item,
    );
  }

  public update(itemId: number, item: Partial<LineModel>): Observable<LineModel> {
    return this.apiService.put<LineModel>(`${environment.url.prefixCustoms}v2/management/customs-broker/line-items/${itemId}`, item);
  }

  public delete(itemId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/line-items/${itemId}`);
  }

  // Atomic; verified against swagger 2026-08-05: raw int32[] body, 200 no body, Auth roles: CustomsBroker —
  // same contract as the user-side LineItemsRepository.bulkDelete. Batch capped by LINE_ITEMS_BULK_DELETE_LIMIT on the FE.
  public bulkDelete(ids: number[]): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/management/customs-broker/line-items/bulk-delete`, ids);
  }
}
